/** The product name. Used in the wordmark, page titles and authenticator apps. */
export const PRODUCT_NAME = "KuduRMS";

/**
 * Version of the privacy policy + data processing agreement shown at sign-up. Must match the
 * API's CURRENT_LEGAL_VERSION (api/src/gdpr/gdpr-service.ts); the API rejects anything else.
 */
export const LEGAL_VERSION = "2026-10-12";

export interface RuntimeConfig {
  /** Same-origin path to the API; CloudFront routes it to API Gateway. */
  apiBase: string;
  region: string;
  userPoolId: string;
  userPoolClientId: string;
}

/**
 * Written by the deploy (CDK) next to index.html, so one build serves every stage.
 * Locally, `npm run config:dev -w web` writes it from the dev stack's outputs.
 */
export async function loadConfig(): Promise<RuntimeConfig> {
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) throw new Error("config.json is missing. Run `npm run config:dev -w web` for local development.");
  const config = (await res.json()) as Partial<RuntimeConfig>;
  for (const key of ["apiBase", "region", "userPoolId", "userPoolClientId"] as const) {
    if (!config[key]) throw new Error(`config.json is missing ${key}`);
  }
  return config as RuntimeConfig;
}
